module.exports = __webpack_public_path__ + "static/media/letterTemplateText.c11c2757.png";